import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactBeneficiaryComponent } from './contact-beneficiary.component';
import { AvatarModule } from '../avatar/avatar.module';
import { MatButtonModule } from '@angular/material/button';
import { ContactDialogModule } from '../contact-dialog/contact-dialog.module';



@NgModule({
  declarations: [
    ContactBeneficiaryComponent
  ],
  exports: [
    ContactBeneficiaryComponent
  ],
  imports: [
    CommonModule,
    AvatarModule,
    MatButtonModule,
    ContactDialogModule
  ]
})
export class ContactBeneficiaryModule { }
